import { useRef } from 'react';

export default function useInputFocus () {
  const elem = useRef( null );
  const setFocus = () => elem.current && elem.current.focus();

  return [ setFocus, elem ];
}
